// @flow
import Time from './Time';

export type { Props } from './Time';

export default Time;